import { styled } from 'styled-components';

const Operations = styled.div`
  border-bottom: 1.5px solid #afafaf;
  &:hover {
    opacity: 0.7;
  }
`;

export { Operations };
